import React from 'react';

import { BooleanInput, SelectInput, required } from 'react-admin';

import { Box } from '@mui/material';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import nonEmptySelection from '../../../utils/reports/nonEmptySelection';
import RuleSelector from '../../../utils/RuleSelector';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const errorPingsChoices = [
  { id: 'include', name: 'Include' },
  { id: 'without', name: 'Exclude' },
  { id: 'only', name: 'Only error pings' },
];

const RuleStatistics = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Only rules active during this date range are considered. Rules with an end date before 'Date from' or created after 'Date to' are excluded. Both dates are required.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[required(), isPastDate, dateRangeValidation]} source="report.from" label="From *" helperText={false} />
        )}
        to={(
          <SmartDateInput fullWidth validate={[required(), dateRangeValidation]} source="report.to" label="To *" helperText={false} />
        )}
      />
    </FieldBox>
    <FieldBox title="Currency *" description="Only transaction requests in this currency will be counted. Required.">
      <SelectInput
        label=""
        choices={[{ id: 'EUR', name: 'EUR' }, { id: 'SEK', name: 'SEK' }]}
        fullWidth
        source="report.currency"
        validate={[required()]}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Rules" description="Filter to only consider rules with these origination rule IDs. Leave untouched to include all rules.">
      <RuleSelector source="report.originationChainIds" label="" field="originationChainId" helperText={false} validate={[nonEmptySelection]} />
    </FieldBox>
    <FieldBox title="Error pings" description="Choose whether to include all pings, exclude error pings, or only include error pings.">
      <SelectInput
        choices={errorPingsChoices}
        fullWidth
        label=""
        source="report.errorPings"
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Test rules" description="If enabled, only test rules are included in the report. If disabled, only non-test rules are included." inline>
      <BooleanInput source="report.onTestRules" label="" helperText={false} defaultValue={false} />
    </FieldBox>
  </Box>
);

export default RuleStatistics;
